const triggerAutomate = async (data: string) => {
  const res = await fetch(
    `${process.env.REACT_APP_API_URL}/triggerautomateflow`,
    {
      method: "POST",
      body: data,
      headers: {
        "content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
  return (data = await res.json());
};

const getProducts = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/config`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  });
  return await res.json();
};

const getSampleProducts = async () => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}/sampleproducts`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  });
  return await res.json();
};

const validateCaptcha = async (captchaValue: string) => {
  return await fetch(`${process.env.REACT_APP_API_URL}/verify`, {
    method: "POST",
    body: JSON.stringify({ captchaValue }),
    headers: {
      "content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    },
  });
};

const PowerService = {
  triggerAutomate,
  getProducts,
  validateCaptcha,
  getSampleProducts
};
export default PowerService;
